class BackInStock extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.updateSubmitState()
  }

  setupListeners () {
    super.setupListeners()

    this.handleOpen = this.handleOpen.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleEmailInput = this.handleEmailInput.bind(this)

    this.listeners.add(document, 'click', this.handleOpen)

    if (this.els?.submit?.element) {
      this.listeners.add(this.els.submit.element, 'click', this.handleSubmit)
    }

    if (this.els?.email?.element) {
      this.listeners.add(
        this.els.email.element,
        'input',
        this.handleEmailInput,
      )
      this.listeners.add(this.els.email.element, 'blur', this.handleEmailInput)
    }
  }

  handleOpen (event) {
    const triggerEl = event.target.closest(this.externalEls?.trigger?.selector)

    if (!triggerEl) return

    this.setTriggerData(triggerEl)
    this.updateDrawerTitle(triggerEl)
    this.resetState()
  }

  handleSubmit () {
    const emailEl = this.els?.email?.element
    const submitEl = this.els?.submit?.element

    if (this.isGuest) {
      if (!emailEl) {
        console.error('Missing guest email input.')
        return
      }

      if (!emailEl.checkValidity()) {
        emailEl.reportValidity()
        this.updateSubmitState()
        return
      }
    }

    const email = this.isGuest
      ? emailEl?.value?.trim() || ''
      : submitEl?.dataset?.customerEmail?.trim() || ''

    const variantId = this.dataset.variantId
    const productId = this.dataset.productId
    const productUrl = this.dataset.productUrl
    const productImage = this.dataset.productImage
    const productPrice = this.dataset.variantPrice || 0
    const topic = this.dataset.topic

    if (!variantId || !productId || !productUrl) {
      console.error('Missing product details for back-in-stock subscription.')
      return
    }

    if (!email) {
      console.error('Missing email for back-in-stock subscription.')
      return
    }

    const product = {
      epi: variantId,
      empi: productId,
      du: productUrl,
      iu: productImage || '',
      pr: productPrice,
    }

    const onSuccess = () => {
      this.externalEls?.success?.element?.setAttribute('aria-hidden', 'false')
      this.externalEls?.default?.element?.setAttribute('aria-hidden', 'true')
    }

    const onError = (error) => {
      console.error('Subscription failed:', error)
      alert('Something went wrong. Please try again later.')
    }

    window._swat.subscribeForProductAlert(
      email,
      'email',
      product,
      onSuccess,
      onError,
      0,
      topic,
    )
  }

  handleEmailInput () {
    this.updateSubmitState()
  }

  updateSubmitState () {
    const submitEl = this.els?.submit?.element
    const emailEl = this.els?.email?.element

    if (!submitEl) return

    if (!this.isGuest) {
      submitEl.disabled = false
      return
    }

    submitEl.disabled = !emailEl?.validity?.valid
  }

  setTriggerData (triggerEl) {
    this.dataset.variantId = triggerEl.dataset.variantId || ''
    this.dataset.variantTitle = triggerEl.dataset.variantTitle || ''
    this.dataset.productId = triggerEl.dataset.productId || ''
    this.dataset.productUrl = triggerEl.dataset.productUrl || ''
    this.dataset.productImage = triggerEl.dataset.productImage || ''
    this.dataset.variantPrice = triggerEl.dataset.variantPrice || ''
    this.dataset.topic = triggerEl.dataset.topic || 'backinstock'
  }

  updateDrawerTitle (triggerEl) {
    const variantTitle = this.dataset.variantTitle || ''
    const titleEl = this.externalEls?.title?.element

    const showOOSWording = triggerEl.dataset.isCountdown !== 'true'

    if (!titleEl) return

    const titleTemplate =
      showOOSWording === false
        ? titleEl.dataset.titleTemplateCountdown
        : titleEl.dataset.titleTemplate || ''
    titleEl.textContent = titleTemplate.replace('[option]', variantTitle)

    this.externalEls.text.elements.forEach((textEl) => {
      textEl.setAttribute(
        'aria-hidden',
        textEl.dataset.type === 'standard' ? !showOOSWording : showOOSWording,
      )
    })
  }

  resetState () {
    if (this.externalEls?.success?.element) {
      this.externalEls.success.element.setAttribute('aria-hidden', 'true')
    }

    if (this.externalEls?.default?.element) {
      this.externalEls.default.element.setAttribute('aria-hidden', 'false')
    }

    if (this.els?.email?.element) {
      this.els.email.element.value = ''
    }

    this.updateSubmitState()
  }

  get isGuest () {
    return this.dataset.isCustomer !== 'true'
  }
}

if (!customElements.get('back-in-stock')) {
  customElements.define('back-in-stock', BackInStock)
}
